import { useEffect, useState } from "react";
import { Button, ModalBody, ModalHeader } from "reactstrap";
import { SignInFormSection } from "../../pages/signIn/sections/signInForm/signInForm.section";
import { VerifyOtpSection } from "../../pages/createAccount/sections/verifyOtp/verifyOtp.section";
import { CustomModal, Wrapper } from "./signInToCheckout.style";
import { CloseGrayedIcon } from "../../assets/icons/close";
import { useLocation, useNavigate } from "react-router";
import { useCart } from "../../providers/cart.provider";
import { useAuth } from "../../providers/authentication.provider";
import { activateNotification } from "../../utils/notifications-utils";

export const SignInToCheckoutComponent = ({ toggle, isOpen }) => {
  const [step, setStep] = useState(1); // 1 = sign up, 2 = otp
  const [pendingCredentials, setPendingCredentials] = useState(null);
  const [pendingCheckoutTrigger, setPendingCheckoutTrigger] = useState(false);

  const navigate = useNavigate();

  const { handlePendingCheckout } = useCart();
  const { isAuthenticated, isGuestUser, user } = useAuth();

  const handleAuthSuccess = async () => {
    setPendingCheckoutTrigger(true);
  };

  useEffect(() => {
    if (pendingCheckoutTrigger && isAuthenticated) {
      (async () => {
        const pendingResult = await handlePendingCheckout();
        if (pendingResult?.success) {
          navigate("/cart/checkout", { state: pendingResult.data?.data });
        } else {
          activateNotification({
            title: "Checkout Issue",
            body: pendingResult?.message || "Unable to process your checkout.",
          });
          navigate("/cart");
        }
        setPendingCheckoutTrigger(false);
      })();
    }
  }, [pendingCheckoutTrigger, isAuthenticated, user]);

  return (
    <Wrapper className={"checkout-form"}>
      <CustomModal toggle={toggle} centered fullscreen={"lg"} isOpen={isOpen}>
        <ModalHeader className={"!tw-border-0"} toggle={toggle}>
          <div className="close-btn" onClick={() => navigate(-1)}>
            <CloseGrayedIcon />
          </div>
          <span>
            {step === 2 ? "Verify Otp to sign in" : "Sign in to Checkout"}
          </span>
        </ModalHeader>
        <hr />
        <ModalBody>
          {step !== 2 && (
            <>
              <Button
                className={"btn-outline-secondary"}
                href={"/guest-sign-in"}
                outline
              >
                Continue as Guest
              </Button>
              <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-full">
                <hr className="tw-w-64 tw-h-px md:!tw-my-5 !tw-my-5 tw-border-0" />
                <span className="tw-absolute tw-px-3 tw-text-sm tw-font-medium tw-text-gray-900 -tw-translate-x-1/2 tw-bg-white tw-left-1/2 tw-bg-white">
                  OR
                </span>
              </div>
            </>
          )}
          <ModalHeader
            style={{ paddingTop: "0!important" }}
            className={"!tw-pt-0 !tw-mt-0 mb-3"}
          >
            <span>
              {step === 2 ? "Verify Otp" : "Log Into your agrogrid account"}
            </span>
          </ModalHeader>

          {step === 1 ? (
            <SignInFormSection
              onSuccess={handleAuthSuccess}
              setStep={setStep}
              setPendingCredentials={setPendingCredentials}
            />
          ) : (
            <VerifyOtpSection
              onSuccess={handleAuthSuccess}
              pendingCredentials={pendingCredentials}
            />
          )}
        </ModalBody>
      </CustomModal>
    </Wrapper>
  );
};
